import { Box, Button, Flex } from "@chakra-ui/react";
import { SidebarIcon } from "../../../assets/icons/sidebaricon";
import { useGlobalContext } from "@root/context/global-context";
import { useSelector } from "react-redux";
import { getLoggedInUser } from "@root/store/selectors/entities";
import { USER_TYPES } from "@root/constants";
import { ENV_CONFIG } from "@root/config/environment";
import {
  DashboardHeaderRightButton,
  DashboardHeaderRightText,
  DashboardHeaderTitle,
} from "@root/components/kpecDashboard/style";
import { RightArrowIcon } from "@root/assets/icons/rightArrow";
import useSidebar from "@root/hooks/useSidebar";
import { CustomPopup } from "@root/components/common/modals/CustomPopup";
import { LogoutPopupContent } from "@root/pages/components";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";

const SectionHeader: React.FC = () => {
  const { logoutPopup, setLogoutPopup, logoutHandler } = useSidebar();
  const { t } = useTranslation("common");
  const {
    isSidebarOpen,
    setIsSidebarOpen,
    getJournlaistSubscriber,
    userSubscriber,
    setUserSubscriber,
  } = useGlobalContext();
  const isLoggedInUser: any = useSelector(getLoggedInUser);

  // Determine which company name to display
  const companyName = [
    USER_TYPES.SUBSUBSCRIBER,
    USER_TYPES.JOURNALIST,
  ].includes(isLoggedInUser?.role)
    ? userSubscriber?.companyName
    : isLoggedInUser?.companyName;

  useEffect(() => {
    if (
      isLoggedInUser?.role == USER_TYPES.SUBSUBSCRIBER ||
      isLoggedInUser?.role == USER_TYPES.JOURNALIST
    ) {
      getJournlaistSubscriber();
    }
  }, []);

  return (
    <Flex
      justify="space-between"
      alignItems="center"
      w="100%"
      height="68px"
      px="24px"
      borderBottom="1px solid"
      borderColor="#CDD6DC"
      data-tour-item="dashboard-header"
      //bg="#FFFFFF"
    >
      <Flex alignItems="center" gap={5}>
        {isSidebarOpen && (
          <SidebarIcon boxSize={6} onClick={() => setIsSidebarOpen(false)} />
        )}
        <DashboardHeaderTitle>
          {t("kpecDashboard.hello")}
          {isLoggedInUser?.fullName} { }
          {t("kpecDashboard.sir")}
        </DashboardHeaderTitle>

        {isLoggedInUser?.role !== USER_TYPES.ADMIN && (
          <Box
            bg={"#00A1771A"}
            px={"10px"}
            py={"5px"}
            borderRadius={"35px"}
            width={"fit-content"}
            fontWeight={500}
            fontSize={"12px"}
            border={"1px solid #00A177"}
            color={"#00A177"}
          >
            {t("kpecDashboard.org")} {companyName}
          </Box>
        )}
      </Flex>

      {/* {isLoggedInUser?.role != USER_TYPES.SUBSUBSCRIBER && ( */}
      <DashboardHeaderRightButton data-tour-item="header-home-button">
        <DashboardHeaderRightText
          onClick={() => window.open(ENV_CONFIG.IKPEC_HOME_URL, "_blank")}
        >
          {t("kpecDashboard.home")}
        </DashboardHeaderRightText>
        <RightArrowIcon width="20px" height="20px" color="inherit" />
      </DashboardHeaderRightButton>
      {/* )} */}

      {/* {isLoggedInUser?.role == USER_TYPES.SUBSUBSCRIBER && (
        <Button
          bg="#1819B4"
          onClick={() => console.log("to be implemented")}
          height={"44px"}
          width={"fit-content"}
          p="4"
        >
          {t("login.journalistPortal")}
        </Button>
      )} */}

      <CustomPopup
        open={logoutPopup}
        onClose={() => setLogoutPopup(false)}
        title={t("preferences.signOutModalTitle")}
        children={
          <LogoutPopupContent
            onSignOut={logoutHandler}
            onCancel={() => setLogoutPopup(false)}
          />
        }
      />
    </Flex>
  );
};

export default SectionHeader;
